import { FileFieldViewModel } from '@/src/shared/presentation/view-models/file-field.viewModel';

import type { ICMSBlockViewModel } from '../../types/cms-block.viewModel';
import type { PresentationSlideBlock } from '@/src/cms/domain/models/blocks/presentation-slide-block';

export class PresentationSlideBlockViewModel implements ICMSBlockViewModel {
  readonly $type = 'presentation-slide-block' as const;

  title: string;

  hide: boolean;

  fieldImage?: FileFieldViewModel;

  constructor(data: { title: string; hide: boolean; fieldImage?: FileFieldViewModel }) {
    this.title = data.title;
    this.hide = data.hide ?? false;
    this.fieldImage = data.fieldImage;
  }

  static presenter(block: PresentationSlideBlock): PresentationSlideBlockViewModel {
    return new PresentationSlideBlockViewModel({
      title: block.title,
      hide: block.hide,
      fieldImage: block.fieldImage
        ? FileFieldViewModel.presenter(block.fieldImage, 'background')
        : undefined
    });
  }
}
